<template>
  <v-card
    outlined
    max-width="340"
    class="tutorial-card px-6 py-8 d-flex flex-column custom-elevation"
  >
    <div
      v-if="image"
      class="d-flex align-center justify-center"
    >
      <img
        :src="getImgUrl(image)"
        width="200"
        height="200"
        class="mt-16 mt-md-10"
      />
    </div>

    <div
      class="pt-4"
      :class="{
        'd-flex flex-column align-center justify-center': !image,
      }"
    >
      <slot />
    </div>
  </v-card>
</template>

<style>
  .tutorial-card {
    overflow-y: auto;
    width: 100%;
  }
    .tutorial-card > * {
      height: 100%;
    }
</style>

<script>
export default {
  name: 'TutorialCard',
  props: {
    image: {
      type: String,
      default: '',
    },
  },
  methods: {
    getImgUrl(avatar) {
      const images = require.context('@/assets/img/tutorials/', false, /\.png$/);
      return images(`./${avatar}.png`);
    },
  },
};
</script>
